"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DestinationOldSectionNumberingLevel = void 0;
var tslib_1 = require("tslib");
var rtf_old_list_level_info_1 = require("../../model/numbering-lists/rtf-old-list-level-info");
var destination_type_1 = require("../utils/destination-type");
var destination_old_paragraph_numbering_base_1 = require("./destination-old-paragraph-numbering-base");
var DestinationOldSectionNumberingLevel = (function (_super) {
    tslib_1.__extends(DestinationOldSectionNumberingLevel, _super);
    function DestinationOldSectionNumberingLevel(importer, levelNumber) {
        var _this = _super.call(this, importer) || this;
        importer.importers.numbering.oldListLevelInfo = new rtf_old_list_level_info_1.RtfOldListLevelInfo();
        _this.levelNumber = levelNumber;
        return _this;
    }
    Object.defineProperty(DestinationOldSectionNumberingLevel.prototype, "destinationType", {
        get: function () { return destination_type_1.DestinationType.DestinationOldSectionNumberingLevel; },
        enumerable: false,
        configurable: true
    });
    DestinationOldSectionNumberingLevel.prototype.createClone = function () {
        var result = new DestinationOldSectionNumberingLevel(this.importer, this.levelNumber);
        return result;
    };
    DestinationOldSectionNumberingLevel.prototype.beforePopRtfState = function () {
        _super.prototype.beforePopRtfState.call(this);
        this.importer.importers.numbering.oldListLevelInfoCollection.getByIndex(this.levelNumber).copyFrom(this.createRtfOldListLevelInfo());
    };
    DestinationOldSectionNumberingLevel.prototype.createRtfOldListLevelInfo = function () {
        var result = new rtf_old_list_level_info_1.RtfOldListLevelInfo();
        return result;
    };
    return DestinationOldSectionNumberingLevel;
}(destination_old_paragraph_numbering_base_1.DestinationOldParagraphNumberingBase));
exports.DestinationOldSectionNumberingLevel = DestinationOldSectionNumberingLevel;
